/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * This module helps you to create a language selector.
 *
 * @class LanguageSelector
 * @static
 * @extends Object
 * @namespace L
 * @module Widgets
 */
define(['display/map'],
    function(L) {
        'use strict';

        function onPropertyChange(e) {
            var value = e.target.options[e.target.selectedIndex].value;
            e.target.localeService.setCurrentLocale(value);
        }

        function addOptions(select, values) {
            var option;
            values.forEach(function(value) {
                option = document.createElement('option');
                option.text = value.getLabel();
                option.value = value.getLanguageCode();
                select.add(option);
            });
        }

        function setCurrentLocale(select) {
            var i;
            var locale = select.localeService.getCurrentLocale();
            var langCode = locale.getLanguageCode();
            //sets selected index to correct value
            for (i = 0; i < select.options.length; ++i) {
                if (select.options[i].value === langCode) {
                    select.selectedIndex = i;
                    select.options[i].selected = 'selected';
                }
            }
        }

        return {
            /**
             * Returns a {{#crossLink "HTMLSelectElement"}}{{/crossLink}} filled with the supported locales.
             *
             * The element has a function bound to its <i>onchange</i> event, which updates the locale configuration
             * of the {{#crossLink "LocaleService"}}{{/crossLink}} instance given as the first argument.
             *
             * @method getHtmlElement
             * @param {LocaleService} localeService Locale service which will be bound to the generated dropdown.
             * @param {"routing"|"search"|"traffic"|"maps"} [serviceType] Determines the list of languages.
             *  - If you do not provide this parameter or you  provide an invalid one, all languages will be included.
             *  - If you pass a value, only languages specific for the given service's type will be added.
             * @return {HTMLSelectElement}
             */
            getHtmlElement: function(localeService, serviceType) {
                var select;
                if (!localeService) {
                    console.error('Locale service not passed to languageSelector!');
                    return undefined;
                }
                select = document.createElement('select');
                select.localeService = localeService;
                select.className = 'tomtom-language-selector';
                addOptions(select, L.LocaleService.getLocalesFor(serviceType));
                setCurrentLocale(select);
                select.onchange = onPropertyChange;
                return select;
            }
        };
    });



// WEBPACK FOOTER //
// ./widgets/controls/languageSelector.js